import api from "./rnplNotAdminService";

export function analyzeBankStatement(body) {
  return api
    .post(`/financial/bank-statement-analysis`, body)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/rnplFinancials.js
// module id = null
// module chunks = 